import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { SERVICES_DATA } from '../data/servicesData';
export function ServicesList() {
  return <div className="min-h-screen bg-brand-light" data-id="element-903" data-mp="1xnp8r3bbg8j1">
      {/* Hero Band */}
      <div className="bg-brand-navy py-20 relative overflow-hidden" data-id="element-904" data-mp="1sn1f09vpddl4">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none" data-id="element-905" data-mp="1spxcxy7jw29k">
          <div className="absolute -top-[50%] -right-[10%] w-[70%] h-[150%] rounded-full bg-brand-red/5 blur-[120px]" data-id="element-906" data-mp="26kzkeps1pzoh" />
        </div>
        <div className="max-w-brand mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-907" data-mp="2gdeyhc082443">
          <span className="text-brand-gold font-semibold tracking-wider text-sm uppercase mb-4 block" data-id="element-908" data-mp="2bdix7kiwsqs8">
            Our Expertise
          </span>
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-white mb-6" data-id="element-909" data-mp="2pe3ci6pm84gz">
            Comprehensive Healthcare Services
          </h1>
          <p className="text-lg text-slate-300 max-w-2xl mx-auto leading-relaxed" data-id="element-910" data-mp="2k23sj221wxye">
            From general consultations to specialized diagnostics, Maisha
            Medical Center provides a complete range of medical services to keep
            you and your family healthy.
          </p>
        </div>
      </div>

      {/* Services Grid */}
      <div className="py-20" data-id="element-911" data-mp="2y2oe25zcp7vl">
        <div className="max-w-brand mx-auto px-4 sm:px-6 lg:px-8" data-id="element-912" data-mp="330g5kyw32rz9">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-913" data-mp="3307rj3o85gmh">
            {SERVICES_DATA.map((service, idx) => <motion.div key={service.slug} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: idx * 0.05,
            duration: 0.4
          }} className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-soft-lg transition-all duration-300 border border-slate-100 group relative overflow-hidden flex flex-col" data-id="element-914" data-mp="3bs9pmvatmktl" data-mpi={idx}>
                <div className="absolute top-0 left-0 w-full h-1 bg-brand-red transform -translate-x-full group-hover:translate-x-0 transition-transform duration-500 ease-out" data-id="element-915" data-mp="3arpwxerc9lsg" />

                <div className="w-14 h-14 bg-brand-lighter rounded-xl flex items-center justify-center mb-6 text-brand-gold group-hover:bg-brand-navy group-hover:text-white transition-colors duration-300" data-id="element-916" data-mp="35ywsyt3p2hhf">
                  {service.icon}
                </div>

                <h3 className="text-xl font-heading font-bold text-brand-navy mb-3 group-hover:text-brand-red transition-colors" data-id="element-917" data-mp="3tpj2kotck9tj">
                  {service.title}
                </h3>

                <p className="text-slate-600 text-sm mb-8 flex-grow" data-id="element-918" data-mp="1zbrkd0wychmh">
                  {service.shortDesc}
                </p>

                <div className="flex items-center justify-between pt-4 border-t border-slate-50 mt-auto" data-id="element-919" data-mp="1uf13wch8jk0j">
                  <Link to={`/services/${service.slug}`} className="text-sm font-medium text-brand-navy hover:text-brand-red transition-colors flex items-center gap-1" data-id="element-920" data-mp="9w7ew1jd6w16">
                    Learn More <ArrowRight className="w-4 h-4" data-id="element-921" data-mp="54fllj8tqc7c" />
                  </Link>
                  <Link to={`/book?service=${service.slug}`} className="text-xs font-semibold bg-brand-lighter text-brand-navy px-3 py-1.5 rounded-lg hover:bg-brand-red hover:text-white transition-colors" data-id="element-922" data-mp="52cmm9pp18qh">
                    Book
                  </Link>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </div>;
}